import { Link } from "react-router-dom";
import { Plus, ArrowUpRight } from "lucide-react";
import { useInquiry } from "../context/InquiryContext";
import { pimg, formatCategoryName } from "../lib/site";
import { Reveal } from "./motion/Reveal";

const ProductCard = ({ product, index = 0 }) => {
  const { addItem } = useInquiry();
  return (
    <Reveal delay={(index % 4) * 0.08}>
      <div
        className="group border border-black/10 bg-white transition-colors duration-300 hover:border-brand-ink"
        data-testid={`product-card-${product.id}`}
      >
        <Link
          to={`/products/${product.id}`}
          className="block aspect-[4/3] overflow-hidden bg-brand-smoke"
        >
          <img
            src={pimg(product.images[0], 900, 700)}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover grayscale-[25%] transition duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0"
          />
        </Link>
        <div className="p-5">
          <div className="flex items-center justify-between gap-2">
            <span className="mono-caption text-neutral-400">{formatCategoryName(product.category)}</span>
            <span className="font-mono text-[11px] uppercase tracking-wider text-brand-red">
              MOQ {product.moq} {product.moq_unit || "pieces"}
            </span>
          </div>
          <h3 className="mt-3 font-display text-xl font-medium tracking-tight text-brand-ink">
            {product.name}
          </h3>
          <p className="mt-1 line-clamp-2 text-sm text-neutral-500">{product.tagline}</p>
          <div className="mt-5 flex gap-2">
            <Link
              to={`/products/${product.id}`}
              data-testid={`view-product-${product.id}`}
              className="btn-outline flex-1 !h-10 !px-3 !text-[11px]"
            >
              View <ArrowUpRight size={14} />
            </Link>
            <button
              type="button"
              data-testid={`add-to-inquiry-${product.id}`}
              aria-label={`Add ${product.name} to inquiry`}
              onClick={() =>
                addItem({
                  product_id: product.id,
                  product_name: product.name,
                  quantity: product.moq,
                  color: "",
                  size: "",
                })
              }
              className="btn-outline !h-10 !w-10 !px-0"
            >
              <Plus size={16} />
            </button>
            <Link
              to={`/inquiry?product=${product.id}`}
              data-testid={`request-quote-${product.id}`}
              className="btn-primary flex-1 !h-10 !px-3 !text-[11px]"
            >
              Quote
            </Link>
          </div>
        </div>
      </div>
    </Reveal>
  );
};

export default ProductCard;
